function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xb6d9ef;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};

    var sprites;

    var counter;
    var itemsPositionsObject = {
        btn_d: { x: 48, y: 365, w: 603, h: 87, n: "btn_d" },
        btn_c: { x: 48, y: 268, w: 603, h: 87, n: "btn_c" },
        btn_b: { x: 48, y: 172, w: 603, h: 87, n: "btn_b" },
        btn_a: { x: 48, y: 78, w: 603, h: 87, n: "btn_a" },
        palla: { x: 529, y: 424, w: 251, h: 134, n: "palla" },
        palla_cut_04_d: { x: 547, y: 367, w: 89, h: 89, n: "palla_cut_04_d" },
        palla_cut_04_c: { x: 275, y: 275, w: 89, h: 89, n: "palla_cut_04_c" },
        palla_cut_04_b: { x: 431, y: 183, w: 89, h: 89, n: "palla_cut_04_b" },
        palla_cut_04_a: { x: 180, y: 85, w: 89, h: 89, n: "palla_cut_04_a" },
        s_04: { x: 61, y: 44, w: 604, h: 488, n: "s_04" },
        palla_cut_03_d: { x: 549, y: 367, w: 89, h: 89, n: "palla_cut_03_d" },
        palla_cut_03_c: { x: 272, y: 275, w: 89, h: 89, n: "palla_cut_03_c" },
        palla_cut_03_b: { x: 346, y: 183, w: 89, h: 89, n: "palla_cut_03_b" },
        palla_cut_03_a: { x: 439, y: 85, w: 89, h: 89, n: "palla_cut_03_a" },
        s_03: { x: 61, y: 43, w: 604, h: 488, n: "s_03" },
        palla_cut_02_d: { x: 475, y: 367, w: 89, h: 89, n: "palla_cut_02_d" },
        palla_cut_02_c: { x: 485, y: 278, w: 89, h: 89, n: "palla_cut_02_c" },
        palla_cut_02_b: { x: 431, y: 183, w: 89, h: 89, n: "palla_cut_02_b" },
        palla_cut_02_a: { x: 274, y: 85, w: 89, h: 89, n: "palla_cut_02_a" },
        s_02: { x: 61, y: 43, w: 604, h: 488, n: "s_02" },
        palla_cut_01_d: { x: 554, y: 367, w: 89, h: 89, n: "palla_cut_01_d" },
        palla_cut_01_c: { x: 363, y: 276, w: 89, h: 89, n: "palla_cut_01_c" },
        palla_cut_01_b: { x: 431, y: 183, w: 89, h: 89, n: "palla_cut_01_b" },
        palla_cut_01_a: { x: 261, y: 85, w: 89, h: 89, n: "palla_cut_01_a" },
        s_01: { x: 61, y: 42, w: 604, h: 488, n: "s_01" },
        palla_cut: { x: 494, y: 265, w: 89, h: 89, n: "palla_cut" }

    };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {
        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {
        gameData.numItems = 3;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(335, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('palestra', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 905;
        sprites.btn_gioca.y = 298;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var numBallsPlayed = 0;
    var buttonsContainer = new Container();


    container.addChild(buttonsContainer);
    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var itemsNames = ['a', 'b', 'c', 'd'];
    var sceneElements = {};
    var scaffoldsNames = ['01', '02', '03', '04'];
    var currentScaffoldName;
    var answers = {
        '01': { 'a': false, 'b': false, 'c': true, 'd': false },
        '02': { 'a': false, 'b': false, 'c': false, 'd': true },
        '03': { 'a': false, 'b': true, 'c': false, 'd': false },
        '04': { 'a': true, 'b': false, 'c': false, 'd': false }
    };






    initScene();

    function initScene() {
        var i;
        var itemName;
        var spriteItem;
        var pos;
        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            spriteItem = game.sprites[itemName];
            pos = positions["s_" + itemName];
            spriteItem.position.set(pos.x, pos.y);

            container.addChild(spriteItem);
            sceneElements[itemName] = spriteItem;

        }
        for (i = 0; i < itemsNames.length; i++) {
            itemName = itemsNames[i];
            spriteItem = new Sprite(game.sprites.palla_cut_errore.texture);
            sceneElements["palla_cut_errore" + itemName] = spriteItem;
            container.addChild(spriteItem);

            //recycle

            pos = positions['btn_' + itemName];
            spriteItem = new Sprite(spriteItem.texture);
            spriteItem.position.set(pos.x, pos.y);
            spriteItem.width = pos.w;
            spriteItem.height = pos.h;
            spriteItem.alpha = 0;
            spriteItem.interactive = true;
            spriteItem.buttonMode = true;
            buttonsContainer.addChild(spriteItem);
            sceneElements[itemName] = spriteItem;
            spriteItem.alpha = 0;

        }

        var palla = game.sprites.palla;
        palla.position.set(positions.palla.x, positions.palla.y);
        container.addChild(palla);
        sceneElements.palla = palla;

        var palla_cut = game.sprites.palla_cut;
        container.addChild(palla_cut);
        sceneElements.palla_cut = palla_cut;


    }


    function clear() {


    }

    function reset() {
        scaffoldsNames = _.shuffle(scaffoldsNames);
        reseBalls();
        resetScaffolds();
        numBallsPlayed = 0;
        setState('newBall');
    }

    function reseBalls() {
        var i;
        var itemName;
        for (i = 0; i < itemsNames.length; i++) {
            itemName = itemsNames[i];
            sceneElements["palla_cut_errore" + itemName].alpha = 0;
        }
        sceneElements.palla_cut.alpha = 0;
        sceneElements.palla.alpha = 1;
    }

    function resetScaffolds() {
        var i;
        var itemName;
        for (i = 0; i < scaffoldsNames.length; i++) {
            itemName = scaffoldsNames[i];
            sceneElements[itemName].visible = false;

        }
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newBall':
                reseBalls();
                resetScaffolds();

                scaffoldsNames.push(scaffoldsNames.shift());
                currentScaffoldName = scaffoldsNames[0];
                sceneElements[currentScaffoldName].visible = true;

                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        if (currentState === "ready") {
            var btnName = "";
            for (i = 0; i < itemsNames.length; i++) {
                if (sceneElements[itemsNames[i]] === e.target) {
                    btnName = itemsNames[i];
                }
            }

            if (btnName === "") {
                return false;
            }
            pos = positions["palla_cut_" + currentScaffoldName + "_" + btnName];
            var ok = answers[currentScaffoldName][btnName];

            if (ok) {

                sceneElements.palla_cut.position.set(pos.x, pos.y);
                renderer.view.dispatchEvent(new Event('answerOk'));
                tl.to(sceneElements.palla_cut, 0.50, { pixi: { alpha: 1 } }).to(sceneElements.palla, 1, { pixi: { alpha: 0 } }, 0.25).addCallback(okComplete, "+=0.3");
                loopSequence = [renderAlways];
                setState('animating');

            } else {
                renderer.view.dispatchEvent(new Event('answerWrong'));

                sceneElements['palla_cut_errore' + btnName].position.set(pos.x, pos.y);
                tl.to(sceneElements['palla_cut_errore' + btnName], 0.20, { pixi: { alpha: 1 }, repeat: 4, yoyo: true }).addCallback(animationComplete, "+=0.3", [sceneElements['palla_cut_errore' + btnName]]);
                loopSequence = [renderAlways];
                setState('animating');
            }


        }

    }

    function okComplete() {
        numBallsPlayed++;
        if (numBallsPlayed < 3) {
            setState('newBall');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function animationComplete(sprite) {
        // sprite.alpha = 0;       
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}